import axios, { AxiosRequestConfig } from "axios"
import { Platform } from "react-native";
import config from "../utils/config";
import { getRootStore } from "./root-store"

let pingFirst = true;

export const createAxios = (instanceConfig?: AxiosRequestConfig) => {
  const { tokenStore: { token } } = getRootStore();
  const { BASE_URL } = config()
  const axiosConfig: AxiosRequestConfig = {
    baseURL: `${BASE_URL}/api`,
    headers: {
      ...(Platform.OS !== 'web' ? {'Accept-Encoding': 'gzip, deflate, br'} : {}),
      Authorization: token ? `Bearer ${token.access_token}` : undefined
    },
    timeout: 15000,
    ...instanceConfig
  };

  let timeoutId = null;
  const axiosInstance = axios.create(axiosConfig);

  axiosInstance.interceptors.request.use(
    async (config) => {
      config.cancelToken = new axios.CancelToken(function executor(cancel) {
        timeoutId = setTimeout(() => cancel('Request Timeout'), ["get", "GET"].includes(config.method) ? 30000 : 30000);
      });
      if (!pingFirst || config.url === '/ping')
        return Promise.resolve(config);
      let pingTimeoutId = null;
      return axios.head('/ping', {
        baseURL: `${BASE_URL}/api`,
        cancelToken: new axios.CancelToken(function executor(cancel) {
          pingTimeoutId = setTimeout(() => cancel('Request Timeout'), 5000);
        })
      }).then(() => {
        pingFirst = false;
        return config;
      }).finally(() => pingTimeoutId && clearTimeout(pingTimeoutId))
    },
    (error) => {
      timeoutId && clearTimeout(timeoutId);
      pingFirst = true;
      return Promise.reject(error)
    }
  );
  axiosInstance.interceptors.response.use(
    (response) => {
      timeoutId && clearTimeout(timeoutId);
      return response
    },
    (error) => {
      timeoutId && clearTimeout(timeoutId);
      pingFirst = true;
      if (error.response && error.response.status === 401 && token && token.access_token) {
        const rootStore = getRootStore()
        rootStore.reset()
      }
      return Promise.reject(error);
    }
  );
  return axiosInstance;
};

